module.exports = __webpack_public_path__ + "static/media/partypoker.e2299023.svg";